import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../shared/Button';
import styles from './Solutions.module.css';

/* Video slot for this section.
   Either drop a file into public/videos/ and set "src", or paste a
   YouTube / Vimeo embed URL into "embedUrl". Set neither and the
   placeholder below is shown instead. */
const VIDEO = {
  src: '',
  // youtu.be/mMtHWX3Lcyg in its embeddable form. The -nocookie host
  // defers YouTube's tracking cookies until playback actually starts,
  // which matters on a site with no consent banner.
  embedUrl: 'https://www.youtube-nocookie.com/embed/mMtHWX3Lcyg',
  poster: '',
  title: 'Analytica X product walkthrough'
};

const SolutionsVideo = () => {
  if (VIDEO.embedUrl) {
    return (
      <div className={styles.videoFrame}>
        <iframe
          src={VIDEO.embedUrl}
          title={VIDEO.title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          referrerPolicy="strict-origin-when-cross-origin"
          loading="lazy"
          allowFullScreen
        />
      </div>
    );
  }

  if (VIDEO.src) {
    return (
      <div className={styles.videoFrame}>
        <video controls preload="metadata" poster={VIDEO.poster || undefined}>
          <source src={VIDEO.src} />
          Your browser does not support embedded video.
        </video>
      </div>
    );
  }

  return (
    <div className={styles.videoPlaceholder} role="img" aria-label="Video placeholder">
      <span className={styles.videoPlaceholderIcon} aria-hidden="true">▶</span>
      <p className={styles.videoPlaceholderText}>{VIDEO.title}</p>
      <p className={styles.videoPlaceholderHint}>
        Add a video in src/components/sections/Solutions/index.js
      </p>
    </div>
  );
};

const Solutions = () => {
  const navigate = useNavigate();

  const solutions = [
    {
      icon: '📊',
      title: 'Business Intelligence',
      description: 'Transform your raw data into powerful insights with custom dashboards, automated reporting, and real-time analytics.',
      features: [
        'Interactive Dashboards',
        'Automated Reporting',
        'Real-time Analytics',
        'KPI Monitoring'
      ],
      route: '/bi'
    },
    {
      icon: '🤖',
      title: 'Machine Learning',
      description: 'Leverage AI and machine learning to predict trends, automate decisions, and uncover hidden patterns in your data.',
      features: [
        'Predictive Modeling',
        'Customer Segmentation',
        'Demand Forecasting',
        'Anomaly Detection'
      ],
      route: '/ml'
    },
    {
      icon: '☁️',
      title: 'Data Engineering',
      description: 'Build robust data infrastructure with cloud-native solutions, data pipelines, and scalable architectures.',
      features: [
        'Data Pipeline Development',
        'Cloud Migration',
        'Data Warehouse Design',
        'ETL/ELT Processes'
      ],
      route: '/data-engineering'
    },
    {
      icon: '🎯',
      title: 'Strategy Consulting',
      description: 'Develop comprehensive data strategies aligned with your business goals and digital transformation initiatives.',
      features: [
        'Data Strategy Development',
        'Digital Transformation',
        'Process Optimization',
        'Change Management'
      ],
      route: '/strategy'
    }
  ];

  return (
    <section id="solutions" className={`${styles.ourSolutions} section`}>
      <div className="container">
        <h2 className="section-title fade-in">Our Solutions</h2>
        <div className={styles.solutionsSplit}>
          <div className={styles.solutionsGrid}>
          {solutions.map((solution, index) => (
            <div key={index} className={`${styles.solutionCard} fade-in`}>
              <div className={styles.solutionHeader}>
                <div className={styles.solutionIcon}>{solution.icon}</div>
                <h3 className={styles.solutionTitle}>{solution.title}</h3>
              </div>
              <p className={styles.solutionDescription}>{solution.description}</p>
              <ul className={styles.solutionFeatures}>
                {solution.features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
              <Button
                variant="primary"
                onClick={() => solution.route && navigate(solution.route)}
                disabled={solution.disabled}
                className={styles.knowMoreBtn}
              >
                {solution.disabled ? 'Future State' : 'Know More'}
              </Button>
            </div>
          ))}
          </div>

          <aside className={styles.videoColumn}>
            <SolutionsVideo />
          </aside>
        </div>
      </div>
    </section>
  );
};

export default Solutions;